





























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { CartItem } from '@/store/models';
import cart from '@/store/modules/cart';
import user from '@/store/modules/user';
import ui from '@/store/modules/ui';
import fidelitycard from '@/store/modules/fidelitycard';
import { CartItem as CartItemModel } from '@/store/models';
import Modal from '@/components/UI/Modal.vue';
import { redirectToLocation } from '@/commons/redirectManager';
import gtmhelpers from '@/commons/gtmhelpers';
import IconHeart from '@/components/SvgIcons/IconHeart.vue';
import IconTrash from '@/components/SvgIcons/IconTrash.vue';

@Component({
  components: {
    Modal,
    IconHeart,
    IconTrash,
  },
})
export default class CartItemComp extends Vue {
  @Prop() private item!: CartItem;
  @Prop() private isCart!: boolean;

  get isLogged(): boolean {
    return user.isLoggedin;
  }

  get qty(): number {
    return this.item.qty;
  }

  set qty(value: number) {
    this.incrementQty(this.item, value);
  }

  get isSalable(): boolean {
    return this.item.extension_attributes.extis_salable && this.item.extension_attributes.extitem_error === '';
  }

  get isGift(): boolean {
    return cart.isGiftcardCart;
  }

  get isVipQuote(): boolean {
    return cart.cart.extension_attributes && cart.cart.extension_attributes.is_vip_cart;
  }

  private openModal(item: CartItem) {
    ui.openModal('deleteItem' + item.item_id);
  }

  private closeModal(item: CartItem) {
    ui.closeModal('deleteItem' + item.item_id);
  }

  private toggleWishlistModal(direction: boolean, item: CartItem) {
    direction ? ui.openModal('wishlistAdd' + item.item_id) : ui.closeModal('wishlistAdd' + item.item_id);
  }


  private async incrementQty(item: CartItem, qty: number) {
    if (qty < 1 || qty > 999) {
      return;
    }
    if (this.isLogged) {
      fidelitycard.useBonus(0);
    }

    const oldQty = item.qty;
    var productData = gtmhelpers.convertProductsData([item]);
    if(productData.length > 0){
      productData[0].quantity = 1;
    }
    if (qty > oldQty) {
      gtmhelpers.trackAdd(productData,cart.totals.quote_currency_code);
    } else {
      gtmhelpers.trackRemove(productData,cart.totals.quote_currency_code);
    }
    cart.setQty({ itemId: item.item_id, qty });
    cart.updateQty({ item, oldQty });
  }

  private addToWishlist(item: CartItem) {
    var productData = gtmhelpers.convertProductsData([item]);
    gtmhelpers.trackRemove(productData,cart.totals.quote_currency_code);
    gtmhelpers.trackAddToWishlist(productData,cart.totals.quote_currency_code);
    cart.addToWishlist(item.item_id);
  }

  private deleteItem(item: CartItem) {
    if (this.isLogged && !cart.isEmpty) {
      fidelitycard.useBonus(0);
    }
    gtmhelpers.trackRemove(gtmhelpers.convertProductsData([item]),cart.totals.quote_currency_code);
    cart.deleteCartItem(item.item_id);
  }

  private isInDiscount(item: CartItem): boolean {
    return item.price < item.extension_attributes.extoriginal_price;
  }

  private goToProductPage(url: string) {
    redirectToLocation(url);
  }

  get items(): CartItemModel[] {
    return cart.cart.items;
  }
  private proceed(to: string) {
    const route = '/login';
    switch (to) {
      case 'back':
        window.history.go(-1);
        return;
      case 'guestlogin':
      case 'guestregister':
        cart.flagLoading({key: to, value: true});
        break;
      default:
        cart.flagLoading({key: 'guestlogin', value: false});
        cart.flagLoading({key: 'guestregister', value: false});
    }
    // catch to suppress console error "Redirected when going from "/" to "/login" via a navigation guard"
    this.$router.push({path: route}).catch(() => { return; });
  }
}
